import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Hair_18 = ({ hairColours }) => {
  const primary = hairColours.base;
  const secondary = hairColours.shadow;
  return (
    <>
      <g>
        <path
          fill={primary}
          d="M586.4,476.6C574.2,339,612.5,141.8,408,141.8c-193,0-163.2,190.7-180.3,322.4
		c-4.4,33.8-13.4,211.9-13.4,211.9c2-1.5,2.9-3.7,4.5-5.4c2.3,15.8,5.5,22.1,13.8,30.9c-2.2-7-2.8-7.4-2.3-13.7
		c6.8,14.5,27.3,33.6,33,37.5c-3.7-5.5-5-7.7-6-12.2c22.6,13.5,30.5,17.1,50.9,23.2c-10.7-6.5-14.8-9.1-19.8-18
		c16,8.9,41.9,17.8,62.1,21.7c-11-5.8-15.3-8.5-19.5-14.9c14.1,4.7,33.1,6.4,46.9,7.5c-7.6-2.8-15.7-6.6-23.5-10.9
		c13.2-0.2,24.5-1.4,31.8-2.1c-43.6-7.1-68.5-13.6-77.4-57.2c-3.8-18.4-14.1-295.6-14-314.5c0.1-15.4,1.1-59.7,8.7-76.5
		c-0.5,10.9,206.8,5.8,205.4-2.5c8.2,19.2,7.7,69.3,7.7,85.9c0,20.9-0.3,287.6-6.9,308c-14.4,44.9-38.3,50.8-83.3,57.2
		c6.9,1.2,18.2,2.9,31.7,3.6c-6.6,3.5-13.4,6.6-19.8,8.9c13.8-1.1,32.8-2.8,46.9-7.5c-4.2,6.4-8.5,9.1-19.5,14.9
		c20.2-3.9,46.1-12.8,62.1-21.7c-5,8.9-9.1,11.5-19.8,18c20.4-6.1,28.3-9.7,50.9-23.2c-1.1,4.5-2.3,6.7-6,12.2
		c5.8-3.8,26.3-23,33-37.5c0.5,6.3-0.1,6.7-2.3,13.7c8.3-8.7,11.5-15.1,13.8-30.9c1.6,1.7,2.6,3.9,4.5,5.4
		C601.7,676.1,588.8,503.8,586.4,476.6z"
        />
        <path
          fill={primary}
          d="M406.7,145.5c-82.5,0-127.1,78.7-128.7,115.5c-3.2,72.1,21.9,121.4,49.2,165.6c-12.1-33.5-31-115.7-13.1-124.5
		c1.9,6.3,13.2,5.2,20.4,4.3c4.8-0.6,21.6-0.1,27.4,0.8c6.2,1,23.6,0.6,29.9,0.6c6.8,0,11.2-1.4,18.1-1.2c7.2,0.3,53.6-1.3,53.6-1.3
		c-2.6-11.8,3.8-20,6.3-25.4c0,0-6.5,24.6,3.1,27c3.7,0.9,16.9-4.1,32.8-1c12.8,2.5,3.4,83.1-14.5,125.2
		c32.5-47.9,47.8-100.1,46-172C536.5,227.5,489.4,145.5,406.7,145.5z"
        />
        <path
          fill={secondary}
          d="M284.7,255.1c0.2,0.9,0.6,2.4,1.4,3.3c0.3-0.6,1.5-1.2,1.8-1.6c1.1,1.3,4.1,10,7.2,11.3c1.6-2.6,0.8-7.1,1-10
		c0.2,1.2,0.5,6.3,2.1,6.9c2.5,0.9,3.5-4.6,3.6-6.2c1.5,1.1,1.3,3.2,2.3,4.7c1.8-0.7,2.7-2.2,3.7-3.5c1.9,1.2,1.3,3.8,2.7,5.5
		c2.9-2.7,8.8-27.7,13-31.6c0.7,8.9-2.6,20.9,2.7,29.2c0.2-2.4-0.9-6,0.7-8c1.7,2.4,0.8,9.2,4.2,10.2c0.6-2,1-4.6,2-6.3
		c1.1,1.4,1,3.3,2,4.8c0.3,0.2,0.6,0.2,0.9,0.1c1.6-2.1,1.1-5.3,2.9-7c0.5,1.6,0.7,4.8,3,5.3c1.4-2.8,1.1-8.9,3.5-11
		c2-1.8,1.4-0.1,3.8-1.4c3.6-2,6.1-10.3,6.7-11c1-1,1.3-2.8,1.7-3.8c2.6,3,0,24.2,3.5,23.9c2.4-0.2,1.2-9.8,3.8-9.4
		c1.6,0.3,2,4.2,2.4,5.2c2.1-0.2,2.4-3.6,4.4-3.5c1.6,0.1,2.7,4.5,3.1,5.6c2.7-0.9,2.4-2.2,5.1-0.6c2.8,1.7,1.3,3,4.9,1.9
		c3-1,1-2.7,3.8-0.7c1.3,1,1.1,2.8,2.7,3.8c3.9-5.2,7.5-26,7.5-26s0.1,15.4,2.9,22.9c2.3,6.2,3.8-1.8,5.8-3.9c1.1,1.7,1.7,4.3,2,6.3
		c2.8,0.1,5-3.9,7.3-5.3c3.7-2.2,3.8-1.4,5.3,1.6c2.8,5.6,4,0.3,7.6-2.5c0.1,1.8,0,3.6,0.1,5.4c2.8,0.1,2.7-4.4,4.9-5.7
		c0.4,1.5,0.9,6,2,7c3,2.7,6.4-0.6,9.4-2.3c5.9-3.2,4.8-0.5,6.6,3.4c3.1-0.8,3.1-5.2,6.6-6.4c1.1,1.4,1.6,3.5,2.8,4.4
		c1.7-1.8,9.7-19.8,10.1-25c3.8,4.5,5.4,26.7,8,29.6c3.3-1.1,4.4-7.9,6.5-10.5c1.2,1.9,0.2,6.2,1.7,7.6c2.2,2.1,4.7-6.1,6.7-6.9
		c1.4,2.4,1.1,6,3.6,7.8c3.5-1.5,4.1-5.6,6.5-7.8c2.2,1.4,1.5,4.7,3.3,6.2c1.3-1.1,1.9-2.7,3.5-3.6c1.3,1.3,0.7,3.4,2.3,4.8
		c2.3-1.4,9.3-5.5,10.9-7.4c4.6,0.9,2.8,22.9,1.1,26c-2-3.6-2.2-7.9-5.3-11.6c-0.4,4.3,0.2,24-2,28.1c-2.4-2.6-2.8-23-6-25
		c-0.7,1.6-2,9-4.8,9.3c-3.2,0.3-3.3-5.7-3.9-7.3c-0.5,5.3-8.4,15.7-8.4,15.7s-0.6-14.1-3.7-18.6c-2.8,3.1-4,10-4.4,12.7
		c-1.5-0.3-1.9-5.7-2.5-6.8c-3.2,0.6-10,11.1-10,11.1s-2.5-16.2-3.2-18.7c-1.6-5.4-7.7,8.3-9.9,10.1c-1.8-2.7-3.2-5.4-4-8.4
		c-1.6,1.4-1.8,4-3.7,5.2c-0.3-0.8-1.2-1.1-1.6-1.6c-1.1,1.6-2.8,7.8-6.1,5.2c-1.6,2.5-2.5,5.7-4.9,7.8c-1.2-3-2.3-7.1-5-9.4
		c-0.6,2.6-3.5,7.9-3.5,7.9s-8.9-9.8-11.7-13.9c-1.9,6-7.9,20.9-7.9,20.9s-3.8-22.1-6.1-23.5c-1.7,2.7-5.4,6.5-7.3,8.9
		c-1.8-2.2-2.2-5-4.5-6.9c0,1.4-0.7,3.1-1.2,4.3c-1.3-1.5-1.5-3.7-3.9-4.6c-0.4,0.9-1.3,1.6-1.9,2.2c-0.2-0.7-1-1.3-1.2-2
		c-1.2,0.9-2.7,5.6-4.7,5.9c-2.5,0.4-3.7-3.2-5.6-4.5c-0.9,1.2-1.2,2.9-2.3,3.9c-1.5-2-1.9-4.5-4.6-5.6c-0.4,0.9-1,14.6-1,14.6
		s-1.8-10.5-3-10.1c-1.8,0.6-1.8,0.5-3.5,1.6c-1.2,0.8-5-0.8-6.7-0.5c-1.2,3.2-1,9.3-1.7,14.3c-3.1-7-10.9-24.2-12-20
		c-0.8,3.3-4.3,8.2-5.1,11.5c-2.7-0.8-4.2-5.9-6-7.6c0.1,1.7-0.6,3.6-1.5,4.9c-1.7-1.8-3-4.1-5.5-5.3c-3,2.2-1.9,4-6.4,1.1
		c-2.6-1.6-4.4-4.1-6.4-1c-1-0.6-3.3-2.9-4.4-2.9c-2.2,0-1.4,1.9-2.6,3c-3.6,3.1-4-1.8-8.2-2.7c-1.2,1.3-1.7,3.1-3.4,4.2
		c-1.3-1.7-2.6-4.5-5.4-3.3c-1.6,0.7-0.9,3.7-2.7,3.6C282.8,276.8,284.4,257.4,284.7,255.1z"
        />
        <path
          fill={secondary}
          d="M399.2,148.1c0,0-70.2,15.9-93.3,73.6c-15.2,38.1,3.4,73.6,3.4,73.6s-10.7-41,13.5-83.2
		C353.8,158.1,399.2,148.1,399.2,148.1z"
        />
        <path
          fill={secondary}
          d="M417.3,148.5c0,0,70.2,15.9,93.3,73.6c15.2,38.1-3.4,73.6-3.4,73.6s10.7-41-13.5-83.2
		C462.6,158.5,417.3,148.5,417.3,148.5z"
        />
        <path
          fill={secondary}
          d="M406.5,150.3c0,0-54.9,23.8-70.2,68.4c-12.8,37.2,9.3,74.8,9.3,74.8s-9.6-41.6,2.2-76.6
		C359.7,181.9,406.5,150.3,406.5,150.3z"
        />
        <path
          fill={secondary}
          d="M272.7,300.4c0,0-7.3,58-9.3,166.4c-1.7,90.5,1.2,181.8,1.2,181.8s-1.3-101.1,0.3-186.2
		C266.5,377.3,272.7,300.4,272.7,300.4z"
        />
        <path
          fill={secondary}
          d="M288.8,300.4c0,0-7.3,58-9.3,166.4c-1.7,90.5,1.2,181.8,1.2,181.8s-1.3-101.1,0.3-186.2
		C282.6,377.3,288.8,300.4,288.8,300.4z"
        />
        <path
          fill={secondary}
          d="M262.8,291.4c0,0-7.3,58-9.3,166.4c-1.7,90.5,1.2,181.8,1.2,181.8s-1.3-101.1,0.3-186.2
		C256.6,368.3,262.8,291.4,262.8,291.4z"
        />
        <path
          fill={secondary}
          d="M253,288.3c0,0-7.3,58-9.3,166.4c-1.7,90.5,1.2,181.8,1.2,181.8s-1.3-101.1,0.3-186.2
		C246.8,365.3,253,288.3,253,288.3z"
        />
        <path
          fill={secondary}
          d="M544,294.4c0,0,7.3,58,9.3,166.4c1.7,90.5-1.2,181.8-1.2,181.8s1.3-101.1-0.3-186.2
		C550.2,371.3,544,294.4,544,294.4z"
        />
        <path
          fill={secondary}
          d="M527.9,294.4c0,0,7.3,58,9.3,166.4c1.7,90.5-1.2,181.8-1.2,181.8s1.3-101.1-0.3-186.2
		C534.1,371.3,527.9,294.4,527.9,294.4z"
        />
        <path
          fill={secondary}
          d="M553.8,285.3c0,0,7.3,58,9.3,166.4c1.7,90.5-1.2,181.8-1.2,181.8s1.3-101.1-0.3-186.2
		C560.1,362.3,553.8,285.3,553.8,285.3z"
        />
        <path
          fill={secondary}
          d="M563.7,282.3c0,0,7.3,58,9.3,166.4c1.7,90.5-1.2,181.8-1.2,181.8s1.3-101.1-0.3-186.2
		C569.9,359.3,563.7,282.3,563.7,282.3z"
        />
        <path
          fill={secondary}
          d="M411.6,152.1c0,0,54.9,23.8,70.2,68.4c12.8,37.2-9.3,74.8-9.3,74.8s9.6-41.6-2.2-76.6
		C458.4,183.8,411.6,152.1,411.6,152.1z"
        />
        <path
          fill={secondary}
          d="M413.6,153.6c0,0,35.3,36,36.8,77.4c1.2,31.7-17.8,66.3-17.8,66.3s10.1-36.7,7.5-70
		C436.8,183.1,413.6,153.6,413.6,153.6z"
        />
      </g>
    </>
  );
};

export default Hair_18;
